import { useContext, useEffect } from 'react'
import AlertContext from './../context/alert/alertContext'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
const Alerts = (props) => {
    const { alerts, clearAlert } = useContext(AlertContext)
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    useEffect(() => {
        alerts.forEach((alert) => {
            if (!alert?.msg) return
            const msg = props?.translate ? t(alert.msg) : alert.msg
            enqueueSnackbar(msg, {
                variant: alert.type || 'default',
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            })
            clearAlert(alert.id)
        })
    }, [alerts])

    return null
}

export default Alerts
